import { useEffect } from 'react';

import { trackEvent } from '@opendoor/shared-fe/build/analytics';

import { useAppSelector } from 'src/store/hooks';
import { getCurrentSlug, getPageName } from 'src/store/router/selectors';

const TrackPageChange = () => {
  const slug = useAppSelector(getCurrentSlug);
  const pageName = useAppSelector(getPageName);

  // this is triggered on pages in the onboarding flow
  useEffect(() => {
    if (slug) {
      trackEvent('flow-slug', 'change', slug);
    }
  }, [slug]);

  // this is triggered on pages that end with: /p/something
  // pageName will 'something' from the above example
  useEffect(() => {
    if (pageName) {
      trackEvent('flow-complete', 'page', pageName);
    }
  }, [pageName]);

  return null;
};

export default TrackPageChange;
